<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" class="text-center">
          <h1 class="font-weight-bold">404 Not Found</h1>
          <p class="text-muted">お探しのページは見つかりませんでした。</p>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
